// @vendors
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

// @context
import { useAuth } from '../../context/AuthContext';

// @routes
import { PathRoutes } from '../routes/PathRoutes';

interface DashboardNavbarProps {
  hasSubscription?: boolean;
}

const DashboardNavbar: React.FC<DashboardNavbarProps> = ({ hasSubscription = false }: DashboardNavbarProps) => {
  const { userInfo, signOut } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const getLinkClasses = (path: string) => {
    const isActive = pathname === path;
    const baseClasses = "text-gray-900 dark:text-white inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium";
    const activeClasses = isActive ? "border-xervix-primary" : "border-gray-300";

    return `${baseClasses} ${activeClasses}`;
  };

  const handleSignOut = async () => {
    try {
      await signOut();
      toast.success('Sesión cerrada correctamente.');
      navigate('/');
    } catch (error) {
      toast.error('Error al cerrar sesión.');
    }
  };

  const currentPath = () => pathname === PathRoutes.inmobiliaria ? PathRoutes.inmobiliaria : PathRoutes.dashboard;

  return (
    <nav className="bg-xervix-bg-tertiary dark:bg-xervix-bg-tertiary-dark shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              <Link to={PathRoutes.home} className="text-xl font-bold text-xervix-primary">
                XERVIX
              </Link>
            </div>
            <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
              <Link
                to={currentPath()}
                className={getLinkClasses(currentPath())}
              >
                Dashboard
              </Link>
              {hasSubscription && (
                <Link
                  to={PathRoutes.suscription}
                  className={getLinkClasses(PathRoutes.suscription)}
                >
                  Suscripción
                </Link>
              )}
            </div>
          </div>
          <div className="hidden sm:ml-6 sm:flex sm:items-center">
            <div className="ml-3 relative flex items-center space-x-4">
              <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                {userInfo?.name} {userInfo?.lastname}
              </span>
              <button
                onClick={handleSignOut}
                className="px-3 py-1 bg-red-100 text-red-700 hover:bg-red-200 rounded-md text-sm font-medium"
              >
                Cerrar sesión
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default DashboardNavbar;
